theme.headerMainMenuModule=(function(){function mainMenu(){document.querySelectorAll(".header__menu_li").forEach(item=>{if(item.classList.contains("menu__item_has_children")){
  
  // Other Products grid — pure CSS hover, no JS needed
  if(item.classList.contains("header__menu_li_other_products_grid")){
    return;
  }

  let menuItemUrl="",menuItemLocation="";
  
  item.addEventListener("mouseover",event=>{
    if(item.querySelector("details")){
      item.querySelector("details").setAttribute("open","");
    }
    if(item.querySelector("summary")){
      item.querySelector("summary").setAttribute("aria-expanded",!0);
    }
  });
  
  item.addEventListener("mouseleave",event=>{
    if(item.querySelector("details")){
      item.querySelector("details").removeAttribute("open");
    }
    if(item.querySelector("summary")){
      item.querySelector("summary").setAttribute("aria-expanded",!1);
    }
  });
  
  if(item.querySelector("summary")){
    item.querySelector("summary").addEventListener("click",event=>{
      event.stopPropagation();
      menuItemUrl=item.querySelector("summary").dataset.href;
      menuItemLocation=`${window.location.origin}${menuItemUrl}`;
      item.querySelector("details").hasAttribute("open")&&(location.href=`${menuItemLocation}`);
    });
  }

}})}return mainMenu})();